module.exports = "<div>\r\n  <ng-content></ng-content>\r\n</div>\r\n"